import { useDeviceType } from '@cian/ui-kit/responsive';
import * as React from 'react';

import { Controls } from './Controls';
import { DrawButtonContainer as DrawButton } from './DrawButton';
import { GeoLocationButtonContainer as GeoLocationButton } from './GeoLocationButton';
import { HelpLinkButtonContainer as HelpLinkButton } from './HelpLinkButton';
import { ZoomInButtonContainer as ZoomInButton } from './ZoomInButton';
import { ZoomOutButtonContainer as ZoomOutButton } from './ZoomOutButton';
import { ControlsContext, IControlsContext } from './context';
import { useIsPhoneOfferPreviewOpen } from '../../../../common/hooks/useIsPhoneOfferPreviewOpen';

interface IControlsContainerProps {
  ymaps: YMaps.IYMaps;
  map: YMaps.Map;
}

export const ControlsContainer: React.FC<IControlsContainerProps> = ({ ymaps, map }) => {
  const deviceType = useDeviceType();
  const controlsIndentType = deviceType === 'desktop' ? 'L' : 'M';
  // Превью на телефоне лежит поверх геолокации и рисования, их края торчат из-под него (дизайн-ревью 2026-10-07)
  const isBottomHidden = useIsPhoneOfferPreviewOpen();

  const context = React.useMemo<IControlsContext>(() => ({ ymaps, map }), [ymaps, map]);

  return (
    <ControlsContext.Provider value={context}>
      <Controls
        help={<HelpLinkButton />}
        drawPolygon={<DrawButton />}
        zoomIn={<ZoomInButton />}
        zoomOut={<ZoomOutButton />}
        geoLocation={<GeoLocationButton />}
        isBottomHidden={isBottomHidden}
        indent={controlsIndentType}
      />
    </ControlsContext.Provider>
  );
};

ControlsContainer.displayName = 'ControlsContainer';
